import { Order_By } from "@/graphql";
import { ProjectListSortOption } from "@/pages/Projects/constants/SortOptions";

export default function getProjectOrderBy(orderBy: ProjectListSortOption["orderBy"]) {
  if (orderBy?.field === "area") {
    return [{ area: orderBy.direction }, { updatedAt: orderBy.direction }, { createdAt: orderBy.direction }];
  } else if (orderBy?.field === "buildingType") {
    return [{ buildingType: { label: orderBy.direction } }, { updatedAt: orderBy.direction }, { createdAt: orderBy.direction }];
  } else if (orderBy?.field === "favorite") {
    return [{ favorite: Order_By.desc_nulls_last }, { updatedAt: orderBy.direction }];
  } else if (orderBy?.field === "name") {
    return [{ name: orderBy.direction }, { updatedAt: orderBy.direction }, { createdAt: orderBy.direction }];
  } else if (orderBy?.field === "updatedAt") {
    return [{ updatedAt: orderBy.direction }];
  }

  return undefined;
}
